const listeners = new Map();

const eventBus = {
  on(event, handler) {
    if (!event || typeof handler !== "function") return;
    if (!listeners.has(event)) {
      listeners.set(event, new Set());
    }
    listeners.get(event).add(handler);
  },
  off(event, handler) {
    const handlers = listeners.get(event);
    if (!handlers) return;
    handlers.delete(handler);
    if (handlers.size === 0) {
      listeners.delete(event);
    }
  },
  emit(event, payload) {
    const handlers = listeners.get(event);
    if (!handlers) return;
    // Clone to avoid mutation issues if handlers remove themselves.
    Array.from(handlers).forEach((handler) => {
      try {
        handler(payload);
      } catch (_) {}
    });
  }
};

export default eventBus;
